import { Container, Sprite } from '../../odie';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { animate, getRelativeOffset } from '@play-co/timestep-core/ui';
import { getGoals } from 'src/game/scenes/Match2Scene';
import { GoalId, getGoalMap } from '../defs/goal';
import { getGoalsPath } from '../util/assets';

export type GoalCollectedAnimationOptions = {
  id: GoalId;
  scale: number;
  rotation: number;
};

export class GoalCollectedAnimation extends Container implements IAnimation {
  private get icon() {
    return `${getGoalsPath()}${getGoalMap()[this.options.id]}`;
  }

  constructor(private options: GoalCollectedAnimationOptions) {
    super();
  }

  public static assets(): string[] {
    return [];
  }

  public async start(): Promise<void> {
    const goal = this.createGoal();

    await Promise.all([this.flyToGoalBar(goal)]);
  }

  public stop() {}

  private async flyToGoalBar(goal: Sprite) {
    const goals = getGoals()?.getGoal(this.options.id);
    // Just ignore the animation if goals is somehow undefined.
    // This can happen if the game gets closed while playing async animations.
    if (!goals) return;

    goals.addSubview(goal.view);

    // Set initial position.
    const { x, y } = getRelativeOffset(this.view, goals);
    goal.view.updateOpts({
      x,
      y,
    });

    // Animate to goal bar. Move it down a bit to make it look like it's falling. Then move it to the goal bar.
    await animate(goal.view)
      .then(
        {
          x: x,
          y: y + goals.style.height,
        },
        150,
        animate.easeInOut,
      )
      .then(
        {
          x: goals.style.width * 0.5,
          y: goals.style.height * 0.5,
        },
        300,
        animate.easeInOut,
      )
      .toPromise();

    goal.view.removeFromSuperview();
  }

  private createGoal(): Sprite {
    const icon = Sprite.from(this.icon);
    icon.anchorX = 0.5;
    icon.anchorY = 0.5;
    icon.rotation = this.options.rotation;
    icon.scaleX = this.options.scale;
    icon.scaleY = this.options.scale;
    return icon;
  }
}
